(function () {
  'use strict';
  function initialize() {
    var nav = document.querySelector('#shopify-section-header .wwh-desktop-nav');
    if (!nav || nav.dataset.ready) return;
    nav.dataset.ready = 'true';
    var desktop = window.matchMedia('(min-width: 1366px)');
    var items = Array.from(nav.querySelectorAll('.wwh-desktop-nav__item')).map(function (item) {
      return { item: item, button: item.querySelector('.wwh-desktop-nav__toggle'), panel: item.querySelector('.wwh-desktop-nav__panel'), link: item.querySelector('.wwh-desktop-nav__link') };
    });
    var active = null, timer = null;
    function close(restoreFocus) {
      clearTimeout(timer);
      if (!active) return;
      var previous = active;
      active = null;
      previous.panel.hidden = true;
      previous.button.setAttribute('aria-expanded', 'false');
      previous.item.classList.remove('is-open');
      if (restoreFocus) previous.button.focus({ preventScroll: true });
    }
    function open(entry) {
      clearTimeout(timer);
      if (!desktop.matches || !nav.getClientRects().length) return;
      if (!entry.panel) { close(false); return; }
      if (active === entry) return;
      close(false);
      active = entry;
      entry.panel.hidden = false;
      entry.button.setAttribute('aria-expanded', 'true');
      entry.item.classList.add('is-open');
    }
    items.forEach(function (entry) {
      entry.item.addEventListener('pointerenter', function (event) { if (event.pointerType === 'mouse') open(entry); });
      entry.item.addEventListener('pointerleave', function (event) {
        if (event.pointerType !== 'mouse') return;
        timer = setTimeout(function () { if (active === entry && !entry.item.contains(document.activeElement)) close(false); }, 180);
      });
      entry.item.addEventListener('focusin', function (event) { clearTimeout(timer); if (event.target !== entry.button) open(entry); });
      entry.item.addEventListener('focusout', function () { requestAnimationFrame(function () { if (active === entry && !entry.item.contains(document.activeElement)) close(false); }); });
      if (entry.button) entry.button.addEventListener('click', function () { if (active === entry) close(false); else open(entry); });
      entry.item.addEventListener('keydown', function (event) {
        var onTop = event.target === entry.link || event.target === entry.button;
        if (entry.panel && onTop && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
          event.preventDefault(); open(entry);
          var links = entry.panel.querySelectorAll('a[href]');
          var target = event.key === 'ArrowUp' ? links[links.length - 1] : links[0];
          if (target) target.focus();
        } else if (onTop && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(event.key) !== -1) {
          event.preventDefault();
          var index = items.indexOf(entry);
          var next = event.key === 'Home' ? 0 : event.key === 'End' ? items.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + items.length) % items.length;
          var targetItem = items[next];
          (targetItem.link || targetItem.button).focus();
        }
      });
    });
    document.addEventListener('pointerdown', function (event) { if (!nav.contains(event.target)) close(false); });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && active) { event.preventDefault(); close(active.item.contains(document.activeElement)); } });
    desktop.addEventListener('change', function () { if (!desktop.matches) close(false); });
    window.addEventListener('pagehide', function () { close(false); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
